import { HttpInterceptorFn } from '@angular/common/http';
import { createTraceId } from './trace-id';

export const traceIdInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.headers.has('x-correlation-id')) {
    return next(request);
  }

  const traceId = createTraceId();
  const tracedRequest = request.clone({
    setHeaders: {
      'x-correlation-id': traceId,
      'x-trace-id': traceId,
    },
  });

  return next(tracedRequest);
};
